/* eslint-disable react-hooks/exhaustive-deps */
import React, { forwardRef, useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";

/** Utilities */
import { decryptUrlData } from "../../../services/CryptoService";

/** Common Components */
import MolGrid from "../../../components/grid/MolGrid";
import CardSection from "../../../components/ui/card/CardSection";
import CenterModel from "../../../components/ui/centerModel/CenterModel";

/** RTK Query */
import {
  useDeleteProjectComponentMutation,
  useGetProjectComponentListMutation,
} from "../../../app/services/projectComponentAPI";

/** Common Services & Data Files */
import SwalAlert from "../../../services/swalService/SwalService";
import ToastService from "../../../services/toastService/ToastService";

/** Configuration Files */
import { ProjectComponentGridConfig } from "./ProjectComponent/config/ProjectComponent.data";

/** Lazily Loaded Components */
import AddProjectComponent from "./ProjectComponent/features/AddProjectComponent/AddProjectComponent";

const ProjectComponent = forwardRef((props, ref) => {

  const molGridRef = useRef();
  /* State*/
  const [projectComponentGridData, setProjectComponentGridData] = useState();
  const [totalRowCount, setTotalRowCount] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [initData, setInitData] = useState(null);

  const organizationId = useSelector((state) => state.auth.user.organizationId)

  const { confirm } = SwalAlert();
  let projectId = null;
  let projectName = '';
  let projectCode = '';

  const { id } = useParams();
  const projectdata = id ? decryptUrlData(id) : null;

  if (typeof projectdata === 'object' && projectdata !== null) {
    projectId = projectdata.projectId;
    projectName = projectdata.projectName;
    projectCode = projectdata.projectCode;

  } else if (projectdata) {
    projectId = projectdata;
  }

  const cardData = [
    { key: projectCode, value: projectName },
  ];
  // API'S Call
  
  const [getAllProjectComponentList, {
    isLoading: isProjectComponentListLoading,
    isSuccess: isProjectComponentListSuccess,
    data: isLProjectComponentListeData,
  },] = useGetProjectComponentListMutation();

  const [deleteProjectComponent, {
    isSuccess: isProjectComponentDeleted,
    data: deleteProjectComponentData
  },] = useDeleteProjectComponentMutation();

  //** useEffect's */
  useEffect(() => {
    if (isProjectComponentListSuccess && isLProjectComponentListeData) {
      if (isLProjectComponentListeData) {
        setProjectComponentGridData(isLProjectComponentListeData.dataSource);
      }
      if (isLProjectComponentListeData.totalRecord) {
        setTotalRowCount(isLProjectComponentListeData.totalRecord);
      }
    }
  }, [isProjectComponentListSuccess, isLProjectComponentListeData]);

  useEffect(() => {
    if (isProjectComponentDeleted && deleteProjectComponentData) {
      const currentPageObject = molGridRef.current.getCurrentPageObject();
      ToastService.success(deleteProjectComponentData.errorMessage);
      const request = {
        pagination: {
          pageNumber: currentPageObject.pageNumber,
          pageSize: currentPageObject.pageSize,
        },
        filters: { searchText: "" },
      };
      getProjectDataList(request);
    }
  }, [isProjectComponentDeleted, deleteProjectComponentData]);

  useEffect(() => {
    if (molGridRef.current) {
      const currentPageObject = molGridRef.current.getCurrentPageObject();
      const request = {
        pagination: {
          pageNumber: currentPageObject.pageNumber,
          pageSize: currentPageObject.pageSize,
        },
        filters: { searchText: props.search },
      };
      getProjectDataList(request);
    }
  }, [props.search]);

  //** Funcation's */
  const getProjectDataList = (pageObject) => {
    const request = {
      pagination: {
        pageNumber: pageObject.pageNumber,
        pageSize: pageObject.pageSize,
      },
      filters: {
        searchText: props.search,
        searchStatusId: props.selectedStatusOptions,
      },
      OrganizationId: organizationId,
      projectId: projectId,
    };
    getAllProjectComponentList(request);
  };

  const onDeleteClick = (data) => {
    confirm(
      "Delete?",
      "Are you sure you want to Delete?",
      "Delete",
      "Cancel"
    ).then((confirmed) => {
      if (confirmed) {
        deleteProjectComponent(data.projectComponentId);
      }
    });
  };

  const onEditAction = (data) => {
    setInitData(data);
    setIsEdit(true);
    setShowModal(true);
  };

  const AddhandleToggleModal = () => {
    setInitData(null);
    setShowModal(!showModal);
    setIsEdit(false);
    if (molGridRef.current) {
      const currentPageObject = molGridRef.current.getCurrentPageObject();
      const request = {
        pagination: {
          pageNumber: currentPageObject.pageNumber,
          pageSize: currentPageObject.pageSize,
        },
        filters: { searchText: props.search },
      };
      getProjectDataList(request);
    }
  };

  const handlePageChange = (page) => {
    getProjectDataList(page);
  };

  const actionHandler = {
    ADD: AddhandleToggleModal,
    EDIT: onEditAction,
    DELETE: onDeleteClick,
  };

  return (
    <div className="table-style">
      <div className="project-component center-top-space">
        <CardSection
          isContentLoading={isProjectComponentListLoading}
          cardTitle={"Project Component"}
          rightButton={true}
          buttonClassName="theme-btn"
          cardInfo={true}
          cardInfoWrapper={cardData}
          titleButtonClick={AddhandleToggleModal}
          buttonText="Component"
          textWithIcon={true}
          iconName="material-symbols:add-rounded"
          fontIcon={true}
          searchInputName="Search by Project Component"
          searchInput={false}
        >
          <div className="table-grid">
            <div className="project-list">
              <MolGrid
                ref={molGridRef}
                configuration={ProjectComponentGridConfig}
                dataSource={projectComponentGridData}
                isLoading={isProjectComponentListLoading}
                allowPagination={false}
                pagination={{
                  totalCount: totalRowCount,
                  pageSize: 10,
                  currentPage: 1,
                }}
                onPageChange={handlePageChange}
                onActionChange={actionHandler}
              />
            </div>
          </div>
        </CardSection>
      </div>
      <div>
        {showModal && (
          <CenterModel
            showModal={showModal}
            handleToggleModal={AddhandleToggleModal}
            modalTitle={isEdit ? "Update Project Component" : "Add Project Component"}
            modelSizeClass="w-40"
          >
            <AddProjectComponent isEdit={isEdit} componentData={initData} onClose={AddhandleToggleModal} projectId={projectId} />
          </CenterModel>
        )}
      </div>
    </div>
  );
});

ProjectComponent.propTypes = {
  search: PropTypes.string,
  selectedStatusOptions: PropTypes.number,
};

export default ProjectComponent;
